// extracted by mini-css-extract-plugin
module.exports = {"subscribe":"subscribe-module--subscribe--PxaoW","narrow":"subscribe-module--narrow--3xc6l"};